import { render, staticRenderFns } from "./CustomerSpecPage.vue?vue&type=template&id=6711d929&scoped=true&lang=pug&"
import script from "./CustomerSpecPage.vue?vue&type=script&lang=js&"
export * from "./CustomerSpecPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSpecPage.vue?vue&type=style&index=0&id=6711d929&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6711d929",
  null
  
)

export default component.exports